import axios from "axios";
import store from "../store";

class Workers {
	async zip() {
		let jwt = store.state.jwt;

		var opts = {
			headers: {
				Authorization: "bearer " + jwt,
			},
		};

		opts.responseType = "blob";

		return axios
			.post(
				`${process.env.VUE_APP_SAAS_BACK}` + "/scenario/zip_scenarios",
				{},
				opts
			)
			.then((response) => {
					const url = window.URL.createObjectURL(
						new Blob([response.data])
					);
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", "scenarios.zip");
					document.body.appendChild(link);
					link.click();
					return null;
			})
			.catch(async function (error) {
				console.log(error)
				console.log(error.response.status);
			  });
	}

	async rename(name, new_name) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/scenario/rename",
					{
						name,
						new_name,
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async archive(name) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/scenario/archive",
					{
						name,
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async unarchive(uid) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/scenario/unarchive",
					{
						uid,
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async save(name, version, description, description_project, data, test, version_env, sync_env, treatment_params = [], columns_type = {}, details = {}) {
		let jwt = store.state.jwt;

		var structure = [];

		for (var i = 0; i < data.steps.length; i++) {
			if (data.steps[i].action != "projet") {
				structure.push({
					action: data.steps[i].action,
					url_type: data.steps[i].source_data || "",
				});
			} else {
				//console.log(data.steps[i].data.parameters)
				structure.push({
					action: data.steps[i].action,
					project: data.steps[i].data.parameters.project,
					tags: data.steps[i].data.parameters.tags,
					nb_by_lot: data.steps[i].data.parameters.nb_by_lot || null,
					size_max: data.steps[i].data.parameters.size_max || null,
					sequential: data.steps[i].data.parameters.sequential || false,
					column_url: data.steps[i].data.parameters.column_url || "",
					column_file: data.steps[i].data.parameters.column_file || "",
					column_project: data.steps[i].data.parameters.column_project || "",
					column_tags: data.steps[i].data.parameters.column_tags || "",
					url_type: data.steps[i].source_data || "",
					csv: data.steps[i].data.parameters.csv || false,
					conditions: data.steps[i].data.sql_rules || ""
				});
			}
		}

		console.log(treatment_params)

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/scenario/save",
					{
						name,
						version,
						description,
						description_project,
						data,
						structure,
						test,
						version_env,
						sync_env,
						treatment_params,
						columns_type,
						details
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async load(name, version) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/scenario/load",
					{
						name,
						version,
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async getby_production() {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` +
						"/scenario/getby_production",
					{},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data.scenario);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async getby_id(uid) {
		console.log("getby_id " + uid);
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/scenario/getby_id",
					{
						uid,
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data.scenario);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async getby_libelle(name) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/scenario/getby_libelle",
					{
						name,
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data.scenario);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	// Chargement paresseux du contenu complet d'une conversation IA de
	// génération de code persistée sur S3 (cf TODO_CODEGEN_CHAT.md section 4).
	// Ne fournit jamais l'URL S3 brute au front : le back reconstruit la clé
	// à partir de scenario_uid/step_uid/chat_uid + client_uid (JWT).
	async codegen_chat_load(scenario_uid, step_uid, chat_uid) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/scenario/codegen_chat/load",
					{
						scenario_uid,
						step_uid,
						chat_uid,
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	// Suppression définitive (S3) d'une conversation IA de génération de code.
	async codegen_chat_delete(scenario_uid, step_uid, chat_uid) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/scenario/codegen_chat/delete",
					{
						scenario_uid,
						step_uid,
						chat_uid,
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}
}

export default new Workers();
